import { Button } from "@mui/material";

import { useTenantTranslation } from "hooks/formatters";
import { InventoryMeasurementFormState } from "../types";
import { useInventoryMeasurement } from "./InventoryMeasurementProvider";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";

export const InventoryMeasurementSubmitButton = () => {
  const { t } = useTenantTranslation();
  const { canSubmit, handleSubmit, inventoryMeasurementFormState } =
    useInventoryMeasurement();

  // FIXME: replace this with a default_auto_recipe_type tenant param
  const isEstimateMode = useIsBehindFeatureFlag(
    "inventory_measurement_with_estimate"
  );

  return (
    <Button
      variant="contained"
      disabled={!canSubmit}
      loading={
        inventoryMeasurementFormState ===
        InventoryMeasurementFormState.Submitting
      }
      onClick={() =>
        void handleSubmit(isEstimateMode ? "charging" : "medium_term_charging")
      }
    >
      {t("confirm")}
    </Button>
  );
};
